
@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4">
    <div class="row" style="margin-top: 10px !important">
      <div class="col-6 p-3" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
        <h3 class="font-weight-bold">
          {{selected_user_name}}
        </h3>
        <h6 class="font-weight-bold text-black-50">
          {{selected_user_designation}}
        </h6>
      </div>
      <div class="col-xl-6 cl-sm-6 col-12 mt-3">
        <!-- <button type="button" class="btn btn-info float-right all-btn" (click)="addNewAttandance()">
        Add New Sallary
      </button> -->
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-xl-8 col-sm-6 col-12">
      @for (salary of allSalaries; track salary) {
        <div  class="card mt-3 shadow" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          @if (isavailablefeature('isViewPayroll')) {
            <div class="card mt-3 shadow card-content rounded" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
              <div  class="card-body">
                <div class="media d-flex text-center leaves_type-d"  style="font-size: 12px">
                  <div class="col pt-2">
                    <span class="leave-reason">{{salary.month_char}} {{salary.month_year}}</span>
                  </div>
                  <div class="col pt-2">
                    <span class="leave-reason">{{salary.released_salary === null ? "00" : salary.released_salary }}/- PKR</span>
                  </div>
                  <div class="col pt-2">
                    <span class="leave-reason">{{salary.salary_released_date === null ? "--------" : salary.salary_released_date | date: "dd MMM YYYY" }}</span>
                  </div>
                  <div class="col">
                    <!-- *ngIf="checkShort(type.end_date)" -->
                    <a
                      class="btn btn text-white"
                            style="background-color: {{
                            getSaleryColor(salary.status)}};text-transform: capitalize;"
                    >{{salary.status}}</a>
                  </div>
                  <div class="col-xl-1">
                    <a (click)="showDetails(salary)">
                    <img src="assets/aye_icon.svg" width="40px" alt=""/></a>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>

    <div class="col-xl-4 col-sm-6 col-12" style="margin-top: 10px !important">
      @if (isavailablefeature('isCreatePayroll')) {
        <div class="card shadow" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          <form #f="ngForm">
            <div class="card-content">
              <h4
                class="p-1 mt-2 ml-2 text-secondary font-weight-bold weekly-graph"
                >
                Create New Salary
              </h4>
              <div class="">
                <div class="media d-flex font-weight-bold text-secondary">
                  <div class="col">
                    <!-- <span>Start Date</span> -->
                  </div>
                  <div class="col">
                    <!-- <span>End Date</span> -->
                  </div>
                </div>
                <div
                class=" media
                  d-flex
                  text-secondary-light
                  time-detail
                  custom-date-responsive
                  mb-3
                "
                  >
                  <div class="col-6 mt-3">
                    <span class="text-secondary start-date">Name</span>
                    <input
                      type="text"
                      name="name_search"
                      id="enddate"
                      class="date-type form-control"
                      ngModel
                      readonly=true
                      placeholder="{{selected_user_name}}"
                      #enddate="ngModel"
                      />
                    </div>
                  </div>
                  <!-- ........... -->
                  <div  class=" media  d-flex  text-secondary-light time-detail custom-date-responsive mb-3" >
                    <div class="col-6 mt-3">
                      <span class="text-secondary start-date">Designation</span>
                      <input type="text"  name="name_search"  id="enddate" class="date-type form-control"  ngModel
                        readonly=true  placeholder="{{selected_user_designation}}"  #enddate="ngModel" >
                      </div>
                    </div>
                    <!-- ........... -->
                    <!-- ........... -->
                    <div  class=" media  d-flex  text-secondary-light time-detail custom-date-responsive mb-3" >
                      <div class="col-6 mt-3">
                        <span class="text-secondary start-date">Select Month</span>
                        <input type="date"  name="name_search"  id="salary_month" class="date-type form-control"  ngModel
                          #enddate="ngModel" >
                        </div>
                      </div>
                      <!-- ........... -->
                      <div
                class="
                  media
                  d-flex
                  text-secondary-light
                  font-weight-bolder
                  time-detail
                  pt-2
                  pb-3
                "
                style="
                  margin-top: 20px !important;
                  margin-bottom: 30px !important;
                "
                        >
                        <div class="col-xl-8">
                          <button  (click)="assignNewMmonthSalaryy()" type="submit " class="btn btn text-white font-weight-bold mt-1 apply" >
                            Add New Month Salary
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            }
          </div>

        </div>
      </div>
    </main>
